"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazyRender = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // Code adapted from:
// https://github.com/FormidableLabs/formidable-react-starter/blob/master/src/routes/async-route.js

/**
 * Given a promise that returns an ES6 Module which export a React Component on the {exportedName}
 * it will render that component.
 */


var lazyRender = function lazyRender(getComponent) {
  var _class, _temp;

  var exportedName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(AsyncComponent, _React$Component);

    function AsyncComponent() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, AsyncComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AsyncComponent)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        Component: AsyncComponent.Component
      });

      _defineProperty(_assertThisInitialized(_this), "mounted", false);

      return _this;
    }

    _createClass(AsyncComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        if (this.state.Component === null) {
          getComponent().then(function (mod) {
            if (!Object.prototype.hasOwnProperty.call(mod, exportedName)) {
              throw new Error("Module does not export ".concat(exportedName));
            }

            return mod[exportedName];
          }).then(function (Component) {
            AsyncComponent.Component = Component;

            if (_this2.mounted) {
              _this2.setState({
                Component: Component
              });
            }
          })["catch"](function (err) {
            console.error('Dynamic module loading failed:', err); // eslint-disable-line no-console
          });
        }

        this.mounted = true;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: "render",
      value: function render() {
        var Component = this.state.Component;

        if (Component !== null) {
          return _react["default"].createElement(Component, this.props);
        }

        return null;
      }
    }]);

    return AsyncComponent;
  }(_react["default"].Component), _defineProperty(_class, "Component", null), _temp;
};

exports.lazyRender = lazyRender;